import { AbstractControl, ValidatorFn } from '@angular/forms';

export function fileExtensionValidator(supportedExtensions: string[] = null): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (supportedExtensions && control.value && control.value.type) {
      return supportedExtensions.find(elem => control.value.type.includes(elem))
        ? null
        : { fileExtensionValidator: { requiredExtensions: supportedExtensions.join(', ') } };
    }
    return null;
  };
}
